import { render, staticRenderFns } from "./SubmitCount.vue?vue&type=template&id=361411e9&scoped=true"
import script from "./SubmitCount.vue?vue&type=script&lang=js"
export * from "./SubmitCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361411e9",
  null
  
)

export default component.exports